<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3>No results founds for: "{{ searchString }}"</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>Suggested Homes - Minnesota</h3>
      </div>
    </div>
    <div class="card-deck" v-if="houseData.length > 0">
      <home-card v-for="(house, index) in houseData"
        v-bind:key="index"
        v-bind:data="house"
        v-bind:suggestedHouses="true"></home-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AWSConnector from 'http-aws-es'
import elasticsearch from 'elasticsearch'
import AWS from 'aws-sdk/global'
import HomeCard from '../rightSide/HomeCard.vue'

export default {
  mounted () {
    this.performSearch()
    if (this.$route.query.search) this.searchString = this.$route.query.search
  },
  data () {
    return {
      houseData: [],
      searchString: ''
    }
  },
  components: {
    HomeCard
  },
  computed: {
    ...mapGetters([
      'getSecretAccessKey',
      'getAccessKeyId',
      'getSessionToken'
    ]),
    ...mapGetters('homeSearch', [
      'getLastNonEmptyQuery'
    ])
  },
  watch: {
    '$route': function () {
      if (this.$route.query.search) this.searchString = this.$route.query.search
    }
  },
  methods: {
    async performSearch () {
      if (!this.getSecretAccessKey || !this.getAccessKeyId) return
      AWS.config.update({
        credentials: new AWS.Credentials(this.getAccessKeyId, this.getSecretAccessKey, this.getSessionToken),
        region: window.CONFIG.Region
      })
      try {
        var client = new elasticsearch.Client({
          connectionClass: AWSConnector,
          host: window.CONFIG.SearchDomain,
          apiVersion: '6.4'
        })
        const query = {
          bool: {
            must: {
              bool: {
                should: [
                  {match: {city: 'minneapolis'}},
                  {match: {state: 'mn'}}
                ]
              }
            },
            filter: this.getLastNonEmptyQuery
          }
        }
        const results = await client.search({
          index: 'house',
          type: '_doc',
          body: {
            _source: ['house_sqft', 'latitude', 'longitude', 'bedroom_count', 'price', 'bathroom_count', 'state', 'street_name', 'street_number', 'street_suffix', 'city', 'photos', 'brokerage'],
            size: 4,
            query: query
          }
        })
        var houseData = results.hits.hits
        houseData.forEach((house) => {
          if (house._source.photos) house._source.photos.sort()
        })
        this.houseData = houseData
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/homeSearch/leftSide/NoResults.vue